module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Expendable Soldiers "), _c('br'), _vm._v("3 – Counterpunch")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#first-command"
    }
  }, [_vm._v("1.First Command")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#a-change-of-plan"
    }
  }, [_vm._v("2.A Change of Plan")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#a-rescue"
    }
  }, [_vm._v("3.A Rescue")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#helping-a-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.Helping a Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#a-difficult-task",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.A Difficult Task")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#a-mission-to-porlock-harbour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.A Mission to Porlock Harbour")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#a-flight-to-safety",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.A Flight to Safety")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#a-request-for-assistance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.A Request for Assistance")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#taking-the-prize",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.Taking the Prize")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#now-the-hard-part",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.Now the Hard Part")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-escape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.The Escape")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#mission-to-bougainville",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.Mission to Bougainville")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#thanks-to-the-navy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.Thanks to the Navy")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#after-the-freighters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.After the Freighters")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#a-new-posting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.A New Posting")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#attack-at-oro-bay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.Attack at Oro Bay")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#back-at-sea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.Back at Sea")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0